// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"AuthFormWrapper_wrapper__1oK_U","withoutTopPadding":"AuthFormWrapper_withoutTopPadding__b_LtV"};